import { h2FontSize, mobileScreen } from "utils/common";

const PageTitle = (props) => {
  const isServer = typeof window === "undefined";
  const is_h1_title = !!props.is_h1_title;
  const isMobile = !isServer ? window?.innerWidth < mobileScreen : false;
  return (
    <div
      className={`mx-auto ${
        props.hasBorder ? "border-[1rem] border-yellow border-x-0 border-t-0 " : ""
      } ${!props.margin ? " m-8" : props.margin} `}
    >
      {" "}
      {/* ${props.display} */}
      {is_h1_title && (
        <h1
          className={`${props.textSize || "text-5xl"} py-10 flex text-center mx-auto justify-center text-blue font-bold mb-[-1rem]`}
        >
          {props.title}
        </h1>
      )}
      {!is_h1_title && (
        <h2
          className={`  ${h2FontSize} py-10 flex text-center mx-auto justify-center text-blue font-bold mb-[-1rem] ${props.textSize ?? ""}`}
        >
          {isMobile ? (
            props.title
          ) : props.underlineYellow ? (
            <>
              {props.title.split(" ").slice(0, -3).join(" ")}{" "}
              <span className="relative inline-block left-2">
                {props.title.split(" ").slice(-3).join(" ")}
                <span className="absolute bottom-0 left-0 w-full border-t-8 border-yellow"></span>
              </span>
            </>
          ) : (
            props.title
          )}
        </h2>
      )}
    </div>
  );
};

export default PageTitle;
